const SignupLogo = ({ variant, showDesktop = false, extraClass = "" }) => {
    const baseCls = "tw-z-10 tw-absolute tw-h-auto tw-object-contain tw-m-auto";

    const variantCls =
        variant === "brand"
            ? "tw-w-[15%] tw-left-0 tw-top-0"
            : "tw-w-1/4 tw-left-[-6%] tw-bottom-[-3%]";

    const src =
        variant === "brand"
            ? "/assets/images/brand_signup_logo.png"
            : "/assets/images/creator_signup_logo.png";

    return (
        <img
            className={`${baseCls} ${variantCls} ${showDesktop ? "tw-show-desktop" : ""
                } ${extraClass}`}
            src={src}
            alt="."
        />
    );
};
export default SignupLogo;
